// Per-race terms-of-sale page. The backend renders GET /terms/race/:id as a
// plain HTML page (organiser club name, org.nr and the terms text) — a non-hash
// URL, because Vipps MobilePay's sales-unit verifier fetches the registered
// "terms of sale" link and only ever sees the SPA shell behind a hash route.
// The race page links to the same URL so buyers and Vipps read the same page.

export function raceTermsOfSaleUrl(apiServer, raceId) {
    if (!apiServer || !(raceId > 0)) {
        return '';
    }
    return `${`${apiServer}`.replace(/\/+$/, '')}/terms/race/${raceId}`;
}

export function buildRaceTermsOfSaleBody({ text, url, linkLabel }) {
    const parts = [];
    if (typeof text === 'string' && text.trim()) {
        parts.push(text);
    }
    if (url) {
        parts.push(`[${linkLabel}](${url})`);
    }
    return parts.join('\n\n');
}
